import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Columns01 = function Columns01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6.8 3h-.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C3 4.5198 3 5.08 3 6.2v11.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 21 5.08 21 6.2 21h.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C10 19.4802 10 18.9201 10 17.8V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C8.4802 3 7.92 3 6.8 3m11 0h-.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C14 4.5198 14 5.08 14 6.2v11.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218h.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 19.4802 21 18.9201 21 17.8V6.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C19.4802 3 18.9201 3 17.8 3"
    })
  }));
};
export default Columns01;